<div class="flex flex-col w-full gap-2">
  <span class="text-lg font-semibold">
    {{'#LLR_KOMMISSIONIERUNG.DIALOG_GLOBAL.TITEL_BESTELLUNG_UEBERNEHMEN' | translate}}
  </span>
  <span>
    {{'#LLR_KOMMISSIONIERUNG.DIALOG_GLOBAL.LABEL_BESTELLUNG_UEBERNEHMEN' | translate}}
  </span>
  <div class="flex flex-row gap-2 mt-2">
    <button
      class="soft-button secondary w-full h-14"
      (click)="close(false)">
      {{'#LLR_KOMMISSIONIERUNG.DIALOG_GLOBAL.LABEL_ABBRECHEN' | translate}}
    </button>
    <button
      class="soft-button primary w-full h-14"
      (click)="close(true)">
      {{'#LLR_KOMMISSIONIERUNG.DIALOG_GLOBAL.LABEL_FORTFAHREN' | translate}}
    </button>
  </div>
</div>
